import { Controller } from "@hotwired/stimulus"

export default class extends Controller {

  connect() {
    let _this = this;

    this.stickyTitle = document.getElementById("car-show-title");
    this.stickyTitleOffset = this.stickyTitle.offsetTop;

    this.stickyMenu = document.getElementById("car-show-menu");
    this.stickyMenuOffset = this.stickyMenu.offsetTop;

    window.onscroll = function() {
      _this.setStickyHeaders();
      _this.setMenuActiveState();
    };

    this.menu1 = document.getElementById("kepek");
    this.menu1Offset = document.getElementById("kepek").offsetTop - 200;
    this.menu2 = document.getElementById("alapadatok");
    this.menu2Offset = document.getElementById("alapadatok").offsetTop - 200;
    this.menu3 = document.getElementById("felszereltseg");
    this.menu3Offset = document.getElementById("felszereltseg").offsetTop - 200;
    this.menu4 = document.getElementById("contacts");
    this.menu4Offset = document.getElementById("contacts").offsetTop - 200;
  }


  setStickyHeaders() {
    if (window.pageYOffset >= this.stickyMenuOffset) {
      this.stickyMenu.classList.add("c-sticky-car-menu");
    } else {
      this.stickyMenu.classList.remove("c-sticky-car-menu");
    }
  }

  setMenuActiveState() {
    document.getElementsByClassName('c-tab__item').forEach((item) => {
      item.classList.remove('c-tab__item--active');
    })
    if (window.pageYOffset >= this.menu1Offset && window.pageYOffset <= this.menu2Offset ) {
      document.getElementById("menu-1").classList.add('c-tab__item--active');
    } else if (window.pageYOffset >= this.menu2Offset && window.pageYOffset <= this.menu3Offset ) {
      document.getElementById("menu-2").classList.add('c-tab__item--active');
    } else if (window.pageYOffset >= this.menu3Offset && window.pageYOffset <= this.menu4Offset ) {
      document.getElementById("menu-3").classList.add('c-tab__item--active');
    } else if (window.pageYOffset >= this.menu4Offset ) {
      document.getElementById("menu-4").classList.add('c-tab__item--active');
    }
  }
}